import React from "react";

const PolicyPage = () => {
    return (
        <div>
            <h2>
                Privacy Policy
            </h2>
        </div>
    )
}

export default PolicyPage;